import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function PaymentIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>Payment</title>;
    t3 = <path d="M21 28c-4.547 0-7-1.42-7-2v-1.4c1.736.922 4.374 1.4 7 1.4 2.626 0 5.264-.478 7-1.4V26c0 .565-2.329 1.928-6.654 1.997L21 28zM4 23v-1.4c1.736.922 4.374 1.4 7 1.4.337 0 .666-.032 1-.048v2.001l-.665.039A7.325 7.325 0 0111 25c-4.43 0-6.873-1.348-6.995-1.954L4 23zm0-5.4c1.736.922 4.374 1.4 7 1.4 2.626 0 5.264-.478 7-1.4v.615c-2.675.388-4.954 1.306-5.718 2.724-.426.028-.85.061-1.282.061-4.547 0-7-1.42-7-2v-1.4zm0-4c1.736.922 4.374 1.4 7 1.4 2.626 0 5.264-.478 7-1.4V15c0 .581-2.453 2-7 2-4.547 0-7-1.419-7-2v-1.4zm0-4c1.736.922 4.374 1.4 7 1.4 2.626 0 5.264-.478 7-1.4V11c0 .581-2.453 2-7 2-4.547 0-7-1.419-7-2V9.6zM11 5c4.547 0 7 1.419 7 2s-2.453 2-7 2C6.453 9 4 7.581 4 7c0-.566 2.329-1.928 6.654-1.997L11 5zm17 17c0 .58-2.453 2-7 2-4.547 0-7-1.42-7-2 0-.58 2.453-2 7-2 4.43 0 6.873 1.348 6.995 1.954L28 22zm-7-4c-.335 0-.67.01-1.004.025l.001-3.002c0-.007.003-.015.003-.023h-.003L20 7c0-2.571-4.34-3.942-8.72-3.998L11 3C6.527 3 2 4.374 2 7v16c0 2.626 4.527 4 9 4 .409 0 .809-.035 1.213-.058C13.155 28.953 17.098 30 21 30c4.473 0 9-1.374 9-4v-4c0-2.571-4.34-3.942-8.72-3.998L21 18z" fillRule="evenodd" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className || $[7] !== color || $[8] !== props) {
    t4 = <svg className={className} fill={color} height={32} viewBox="0 0 32 32" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}</svg>;
    $[6] = className;
    $[7] = color;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}